import * as actionTypes from "./actionTypes";

export const homeLoadOurPartner = data => {
  return {
    type: actionTypes.HOME_OUR_PARTNER,
    data
  };
};

export const homeLoadOurPartnerSuccess = data => {
  return {
    type: actionTypes.HOME_OUR_PARTNER_SUCCESS,
    data
  };
};

export const mallLoadMainCategoryList = (dataType, data = {}) => {
  return {
    type: actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST,
    dataType,
    data
  };
};

export const mallLoadMainCategoryListSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST_SUCCESS,
    data
  };
};

export const mallLoadMainCategoryListFail = () => {
  return {
    type: actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST_FAIL
  };
};

export const mallLoadCategoryList = (data = {}) => {
  return {
    type: actionTypes.MALL_LOAD_CATEGORY_LIST,
    data
  };
};

export const mallLoadCategoryListSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_CATEGORY_LIST_SUCCESS,
    data
  };
};

export const mallLoadCategoryListFail = () => {
  return {
    type: actionTypes.MALL_LOAD_CATEGORY_LIST_FAIL
  };
};

export const mallLoadAllCategories = (data = {}) => {
  return {
    type: actionTypes.MALL_LOAD_ALL_CATEGORIES,
    data
  };
};

export const mallLoadAllCategoriesSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_ALL_CATEGORIES_SUCCESS,
    data
  };
};

export const mallLoadAllCategoriesFail = () => {
  return {
    type: actionTypes.MALL_LOAD_ALL_CATEGORIES_FAIL
  };
};
